import type { Office } from "@mnk/shared/models/office";
import { Link } from "react-router-dom";
interface Props {
  offices: Office[];
}

export const OfficeListView = ({ offices }: Props) => {
  return (
    <div className="gap-4 bg-white rounded-lg p-4">
      {offices.map((office) => (
        <div key={office.id} className="border-b border-gray-200 rounded-lg p-4">
          <Link to={`/offices/${office.id}`} className="text-md w-full block">
            {office.name}
          </Link>
        </div>
      ))}
    </div>
  );
};
